module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.23.0@babel-runtime/core-js/array/from.js
// module id = 490
// module chunks = 0